import { create } from "zustand"
import {
  getRoles as fetchRoles,
  getPermissions as fetchPermissions,
} from "../services/axiosServices"

let activeRolesPromise = null
let activePermissionsPromise = null

const initialState = {
  roles: [],
  permissions: [],
  loadingRoles: false,
  loadingPermissions: false,
  rolesError: null,
  permissionsError: null,
}

export const rbacStore = create((set, get) => ({
  ...initialState,

  getRoles: async (force = false) => {
    const { roles } = get()
    if (!force && roles.length > 0) return roles

    if (activeRolesPromise) return activeRolesPromise

    activeRolesPromise = (async () => {
      set({ loadingRoles: true, rolesError: null })
      try {
        const res = await fetchRoles()
        const list = res?.data?.data || []
        set({ roles: list, loadingRoles: false })
        return list
      } catch (err) {
        console.error("Failed to load roles:", err)
        set({
          roles: [],
          loadingRoles: false,
          rolesError: "Failed to load roles",
        })
        return []
      } finally {
        activeRolesPromise = null
      }
    })()

    return activeRolesPromise
  },

  getPermissions: async (force = false) => {
    const { permissions } = get()
    if (!force && permissions.length > 0) return permissions

    if (activePermissionsPromise) return activePermissionsPromise

    activePermissionsPromise = (async () => {
      set({ loadingPermissions: true, permissionsError: null })
      try {
        const res = await fetchPermissions()
        const list = res?.data?.data || []

        set({ permissions: list, loadingPermissions: false })
        return list
      } catch (err) {
        console.error("Failed to load permissions:", err)
        set({
          permissions: [],
          loadingPermissions: false,
          permissionsError: "Failed to load permissions",
        })
        return []
      } finally {
        activePermissionsPromise = null
      }
    })()

    return activePermissionsPromise
  },
  clearRbac: () => set(initialState),
}))
